import React, { useState, useEffect } from 'react';

const QUOTES = [
  { text: "If you copy the code, you're only cheating yourself 😉", emoji: '🧠' },
  { text: "You're a great thinker — type it out, don't paste it in!", emoji: '💡' },
  { text: "The struggle you feel right now? That's learning happening.", emoji: '🚀' },
  { text: "Every error message is just a clue. You've got this!", emoji: '🔍' },
  { text: "A real developer Googles things. A great one understands them.", emoji: '⭐' },
  { text: "Type it yourself. Even if it's wrong. Especially if it's wrong.", emoji: '✍️' },
  { text: "The concept section exists for a reason — read it twice 😄", emoji: '📘' },
  { text: "Stack Overflow helped me too. But understanding it is your job.", emoji: '🏆' },
  { text: "One challenge at a time. You're building something real here.", emoji: '💪' },
  { text: "The best Salesforce devs were once exactly where you are now.", emoji: '🌟' },
];

function EinsteinMascot() {
  const [visible, setVisible] = useState(false);
  const [quoteIndex, setQuoteIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Show after 20 seconds
    const showTimer = setTimeout(() => {
      if (!dismissed) {
        setQuoteIndex(Math.floor(Math.random() * QUOTES.length));
        setVisible(true);
      }
    }, 20000);

    return () => clearTimeout(showTimer);
  }, [dismissed]);

  useEffect(() => {
    if (!visible) return;
    // Auto hide after 8 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      // Show again after 2 minutes with different quote
      setTimeout(() => {
        if (!dismissed) {
          setQuoteIndex(Math.floor(Math.random() * QUOTES.length));
          setVisible(true);
        }
      }, 120000);
    }, 8000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);

  const quote = QUOTES[quoteIndex];

  return (
    <div style={{
      position: 'fixed', bottom: '24px', right: '24px',
      zIndex: 9998, display: 'flex', flexDirection: 'column',
      alignItems: 'flex-end', gap: '8px',
    }}>
      {/* Speech bubble */}
      {visible && (
        <div style={{
          background: '#ffffff', border: '1.5px solid #14b8a6',
          borderRadius: '12px', padding: '12px 16px',
          maxWidth: '260px', position: 'relative',
          boxShadow: '0 4px 20px rgba(20,184,166,0.15)',
          animation: 'popIn 0.3s ease',
        }}>
          {/* Close button */}
          <button
            onClick={() => { setVisible(false); setDismissed(true); }}
            style={{
              position: 'absolute', top: '6px', right: '8px',
              background: 'transparent', border: 'none',
              color: '#cccccc', cursor: 'pointer', fontSize: '14px',
              padding: '0', lineHeight: 1,
            }}>✕</button>

          <p style={{
            fontSize: '13px', color: '#111111', lineHeight: '1.6',
            paddingRight: '16px', margin: 0,
          }}>
            {quote.text}
          </p>

          {/* Bubble tail */}
          <div style={{
            position: 'absolute', bottom: '-8px', right: '28px',
            width: '14px', height: '8px',
            background: '#ffffff',
            clipPath: 'polygon(0 0, 100% 0, 50% 100%)',
            borderLeft: '1.5px solid #14b8a6',
            borderRight: '1.5px solid #14b8a6',
          }} />
        </div>
      )}

      {/* Einstein/Astro character button */}
      <div
        onClick={() => {
          setDismissed(false);
          setQuoteIndex((quoteIndex + 1) % QUOTES.length);
          setVisible(true);
        }}
        style={{
          width: '52px', height: '52px', borderRadius: '50%',
          background: 'linear-gradient(135deg, #14b8a6, #0d9488)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', fontSize: '24px',
          boxShadow: '0 4px 16px rgba(20,184,166,0.3)',
          transition: 'transform 0.2s, box-shadow 0.2s',
          border: '3px solid #ffffff',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(20,184,166,0.4)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 16px rgba(20,184,166,0.3)';
        }}
        title="Click for motivation 😄"
      >
        🧑‍🏫
      </div>

      <style>{`
        @keyframes popIn {
          0%  { opacity: 0; transform: scale(0.8) translateY(10px); }
          100%{ opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default EinsteinMascot;